import { render, staticRenderFns } from "./agentProperty.vue?vue&type=template&id=31b99866&"
import script from "./agentProperty.vue?vue&type=script&lang=js&"
export * from "./agentProperty.vue?vue&type=script&lang=js&"
import style0 from "./agentProperty.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports